// Form Component
// ==============

import axios from 'axios';
import Culture from '../culture';
import DOM from '../Library/DOM';
import Locker from '../Library/Locker';
import SendButton from './SendButton';
import Toaster from './Toaster';
import ValidationConnector from './ValidationConnector';

const IS_HU = Culture.getBool();

class Form extends EventTarget {
    constructor(form, sendButtonSelector) {
        super();
        this.form = DOM.getElement(form);
        if (this.form.Action) this.reCaptchaAction = this.form.Action.value;
        this.validation = new ValidationConnector(this.form).validation;
        this.validation.onSuccessCallback = (this.reCaptchaAction)
            ? (e) => { this.captcha(e); }
            : (e) => { this.submit(e); };
        this.sendButtons = [...document.querySelectorAll(sendButtonSelector)].map((x) => {
            x.disabled = false;
            return new SendButton(x);
        });
    }

    captcha(e) {
        e.preventDefault();
        this.lock();
        grecaptcha.ready(() => {
            try {
                grecaptcha.execute(Cookies.get('GRCSK'), { action: this.reCaptchaAction }).then((token) => {
                    this.form.CaptchaToken.value = token;
                    this.submit();
                });
            } catch (ex) {
                this.submit();
            }
        });
    }

    disable(force = true) {
        this.form.querySelectorAll('fieldset').forEach((fieldset) => {
            fieldset.disabled = force;
        });
        this.form.querySelectorAll('label').forEach((label) => {
            label.classList.toggle('disabled', force);
        });
    }

    lock(force = true) {
        const list = this.form.querySelectorAll('button,input:not([type=hidden]),label,select,textarea');
        if (force) {
            list.forEach((element) => {
                Locker.lock(element);
            });
        } else {
            list.forEach((element) => {
                Locker.unlock(element);
            });
        }
    }

    submit() {
        if (this.dispatchEvent(new CustomEvent('submit', { cancelable: true }))) {
            this.lock();
            this.sendButtons.forEach((x) => { x.start(); });
            axios({
                url: this.form.action,
                method: this.form.method,
                data: this.form,
            }).then((response) => {
                if ('success' in response.data) {
                    if (this.dispatchEvent(new CustomEvent('success', { cancelable: true, detail: response.data }))) {
                        if (response.data.success !== '') Toaster.success(response.data.success);
                        this.sendButtons.forEach((x) => { x.success(); });
                        this.disable();
                    }
                } else {
                    if ('error' in response.data) {
                        if (response.data.error !== '') Toaster.error(response.data.error, Toaster.ERROR_CONFIG);
                    }
                    if ('errors' in response.data) {
                        this.validation.showErrors(
                            Object.fromEntries(Object.entries(response.data.errors).map(([key, val]) => [`#${key}`, val])),
                        );
                    }
                    this.dispatchEvent(new CustomEvent('error', { detail: response.data }));
                    this.sendButtons.forEach((x) => { x.stop(); });
                    this.lock(false);
                }
                if ('redirect' in response.data) {
                    window.location = response.data.redirect;
                }
            }).catch(() => {
                Toaster.error(IS_HU ? 'Hiba történt. Kérjük próbálja újra, vagy vegye fel velünk a kapcsolatot!' : 'Something went wrong. Please try again or contact us', Toaster.ERROR_CONFIG);
                this.sendButtons.forEach((x) => { x.stop(); });
                this.lock(false);
            });
        }
    }
}

export default Form;
